import React from "react";
import { useExperiment } from "onnit-ui/lib/hooks/useExperiment";
import Text from "onnit-ui/lib/text";
export var RiskFreeLinkText = function () {
    var variant = useExperiment("FqbhVihgTTmmKWrJzz4vxA");
    if (variant !== undefined) {
        return (React.createElement(Text, { my: 1, display: "block" }, "Try it worry free, cancel anytime."));
    }
    return null;
};
//# sourceMappingURL=RiskFreeLinkText.js.map